// extracted by mini-css-extract-plugin
export var body = "XkJpQ";
export var main = "_13S+T";
export var title = "rUNkk";